// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disclaimer-page {
  width: 100%;
  min-height: 100vh;
  background: #f8fafc;
  padding: 120px 20px 60px;
}

.disclaimer-container {
  max-width: 900px;
  margin: 0 auto;
  background: #ffffff;
  padding: 45px;
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.disclaimer-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 20px;
  line-height: 1.4;
}

.effective-date,
.intro-text {
  font-size: 16px;
  color: #475569;
  margin-bottom: 20px;
  line-height: 1.8;
}

.disclaimer-section {
  margin-bottom: 32px;
}

.disclaimer-section h2 {
  font-size: 24px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 15px;
}

.disclaimer-section ul {
  padding-left: 22px;
  margin: 0;
}

.disclaimer-section li,
.disclaimer-section p {
  font-size: 16px;
  color: #475569;
  line-height: 1.8;
  margin-bottom: 12px;
}

.contact-section a {
  color: #2563eb;
  text-decoration: none;
  font-weight: 500;
}

.contact-section a:hover {
  text-decoration: underline;
}

@media (max-width: 992px) {
  .disclaimer-container {
    max-width: 95%;
    padding: 30px;
  }

  .disclaimer-title {
    font-size: 28px;
  }
}

@media (max-width: 767.98px) {
  .disclaimer-page {
    padding: 100px 15px 40px;
  }

  .disclaimer-container {
    padding: 24px;
    border-radius: 14px;
  }

  .disclaimer-title {
    font-size: 24px;
  }

  .disclaimer-section h2 {
    font-size: 20px;
  }

  .effective-date,
  .intro-text,
  .disclaimer-section li,
  .disclaimer-section p {
    font-size: 16px!important;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/DisclaimerPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,yBAAyB;EAC3B;AACF","sourcesContent":[".disclaimer-page {\n  width: 100%;\n  min-height: 100vh;\n  background: #f8fafc;\n  padding: 120px 20px 60px;\n}\n\n.disclaimer-container {\n  max-width: 900px;\n  margin: 0 auto;\n  background: #ffffff;\n  padding: 45px;\n  border-radius: 18px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n}\n\n.disclaimer-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 20px;\n  line-height: 1.4;\n}\n\n.effective-date,\n.intro-text {\n  font-size: 16px;\n  color: #475569;\n  margin-bottom: 20px;\n  line-height: 1.8;\n}\n\n.disclaimer-section {\n  margin-bottom: 32px;\n}\n\n.disclaimer-section h2 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #0f172a;\n  margin-bottom: 15px;\n}\n\n.disclaimer-section ul {\n  padding-left: 22px;\n  margin: 0;\n}\n\n.disclaimer-section li,\n.disclaimer-section p {\n  font-size: 16px;\n  color: #475569;\n  line-height: 1.8;\n  margin-bottom: 12px;\n}\n\n.contact-section a {\n  color: #2563eb;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.contact-section a:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 992px) {\n  .disclaimer-container {\n    max-width: 95%;\n    padding: 30px;\n  }\n\n  .disclaimer-title {\n    font-size: 28px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .disclaimer-page {\n    padding: 100px 15px 40px;\n  }\n\n  .disclaimer-container {\n    padding: 24px;\n    border-radius: 14px;\n  }\n\n  .disclaimer-title {\n    font-size: 24px;\n  }\n\n  .disclaimer-section h2 {\n    font-size: 20px;\n  }\n\n  .effective-date,\n  .intro-text,\n  .disclaimer-section li,\n  .disclaimer-section p {\n    font-size: 16px!important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
